import { Banknote, TrendingUp, Clock, Shield } from 'lucide-react';
import Capital from "../assets/image/working capital.png"
import Expantion from "../assets/image/business growth.png"
import Credit from "../assets/image/credit line.png"
import Invoice from "../assets/image/invoice.png"
import arrow from "../assets/image/arrow-right.png"
import { useRef, useEffect } from 'react';

export default function Loan() {
  const cardRefs = useRef([]);
    const cardRefs1 = useRef([]);
  const cardRefs2 = useRef([]);

  const headlineRef = useRef(null);
  const descriptionRef = useRef(null);

  
  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-show");
        }
      });
    },
    { threshold: 0.3 }
  );

  // Observe loan cards
  cardRefs.current.forEach((el) => {
    if (el) observer.observe(el);
  });
  cardRefs1.current.forEach((el) => {
    if (el) observer.observe(el);
  });
  cardRefs2.current.forEach((el) => {
    if (el) observer.observe(el);
  });

  // Observe headline
  if (headlineRef.current) observer.observe(headlineRef.current);
   if (descriptionRef.current) observer.observe(descriptionRef.current);

  return () => observer.disconnect();
}, []);


  const loans = [
    {
      id: 1,
      icon: Capital,
      title: "Working Capital Loan",
      description: "For businesses that need steady cash to handle day-to-day operations, from paying vendors to stocking inventory and managing payroll."
    },
    {
      id: 2,
      icon: Expantion,
      title: "Business Expansion Loan",
      description: "Fund your next stage of expansion, whether it's opening a new location, upgrading equipment, or increasing production capacity."
    },
    {
      id: 3,
      icon: Credit,
      title: "Line of Credit",
      description: "Access funds on demand. Use only what you need, when you need it, and pay interest only on the amount used."
    },
    {
      id: 4,
      icon: Invoice,
      title: "Invoice Financing",
      description: "Waiting on payments? Convert unpaid invoices into working capital, no need to chase clients or delay growth plans."
    }
  ];

  return (
    <>
     <style>{`.card-base {
          transition: opacity 0.3s ease-out;
        }

        .animate-show {
          animation: floatIn 0.1s ease-out both;
          opacity: 1;
        }

        @keyframes floatIn {
          0% {
            opacity: 0;
            transform: translateY(5px) scale(0.95);
          }
          100% {
            opacity: 1;
            transform: translateY(0px) scale(1);
          }
        }

        .word-animate {
          display: inline-block;
          opacity: 0;
          transform: translateY(20px);
        }

        .animate-show .word-animate {
          animation: wordReveal 0.2s ease-out forwards;
        }
       

        @keyframes wordReveal {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    <section id='loan' className="py-[60px] sm:py-60 md:py-[60px] lg:py-[72px]  justify-center ">
      <div className='max-w-[1280px] mx-auto px-1  sm:px-6 lg:px-12 '>

          <div className='  flex flex-col  mx-auto -mb-2 sm:-mb-4 lg:-mb-4 max-w-[322px] sm:max-w-[402px] md:max-w-[460px] lg:max-w-[582px]'>

              <div 
    className=" flex justify-center  items-center  mb-6">
              <div ref={descriptionRef}
                    className=" headline-animate w-fit h-fit  border-[#0BA36C] border-[1.5px] rounded-tl-[21px] rounded-tr-[6px] rounded-bl-[5px] rounded-br-[6px] pt-[4px] pr-[16px] pl-[16px] pb-[5px] ">
                <span className=" text-[#0BA36C] text-[16px] font-inter font-semibold">Loans</span>
              </div>
            </div>
            
                 <h2
  ref={headlineRef}
  className="text-[28px] leading-[36px] font-poppins sm:text-[30px] md:text-[48px] lg:text-[48px] sm:leading-[36px] md:leading-[50px] lg:leading-[62px] font-medium -tracking-[4%] text-gray-900 mb-4 text-center"
>
  {["Business", "Loans", "Made", "for"].map((word, i) => (
    <span
      key={i}
      className="word-animate"
      style={{ animationDelay: `${i * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

  

  {["Real", "Business"].map((word, i) => (
    <span
      key={i + 4}
      className="word-animate text-[#0BA36C]"
      style={{ animationDelay: `${(i + 4) * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

  <span
    className="word-animate text-[#0BA36C]"
    style={{ animationDelay: "0.48s" }}
  >
    Needs
  </span>
</h2>

                  <p 
                    className=" text-center text-[#404040] text-[17px]  mb-12 max-w-[460px] mx-auto sm:text-[17px] md:text-[17px] lg:text-[18px] "
                  >
                  Choose the right financing solution to manage cash flow, expand operations, or unlock working capital without any delays or confusion.          </p>
          
          
          </div >

       <div className="max-w-[1280px] mx-auto px-4 sm:px-0 lg:px-0 mt-6">
        {/* Desktop: 2x2 Grid */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-6 xl:gap-8">
          {loans.map((loan) => (
            
            <div key={loan.id} 
            ref={(el) => (cardRefs.current[loan.id] = el)}
            style={{ animationDelay: `${loan.id * 0.2}s` }}
            className=" card-base opacity-0 bg-[#0000000a] rounded-tl-[60px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] border-[0.5px] border-[#00000033]  p-[8px] xl:p-[8px]">
              <div className="flex items-center gap-6">
                <div className=" w-[124px] h-[124px] xl:w-[124px] xl:h-[124px] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <img src={loan.icon} alt='' className='w-full h-full ' />
                </div>

                <div className="flex flex-col min-w-0 w-full bg-white shadow-[0_12px_40px_rgba(0,0,0,0.15)]  pt-[23px] pr-[20px] pb-[24px] pl-[20px] rounded-[12px] gap-[19px]  ]">
                  <div className="flex flex-col w-full ">
                  <h3 className="text-2xl xl:text-[23.06px] font-semibold text-black mb-4 leading-tight">{loan.title}</h3>
                  <p className="text-[#3F3F3F]  max-w-[300px] w-full  xl:text-[16.5px] leading-[25.6px] mb-6">
                    {loan.description}
                  </p>
                  </div>

                  <a
                  href="/contact" 
                  className="text-[#0BA36C] underline text-[19px] font-semibold inline-flex items-center gap-2 group"
                >
                  Let's Start
                  <img
                    src={arrow}
                    alt="arrow"
                    className="w-6 h-6 transition-transform duration-300 -rotate-45 group-hover:rotate-0"
                  />
                </a>

                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tablet: Single Column with Horizontal Layout */}
        <div className="hidden md:block lg:hidden space-y-6 px-6 ">
          {loans.map((loan) => (
             <div key={loan.id} ref={(el) => (cardRefs1.current[loan.id] = el)}
            style={{ animationDelay: `${loan.id * 0.2}s` }}
            className=" card-base bg-[#0000000a] rounded-tl-[60px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] border-[0.5px] border-[#00000033]  p-[8px] xl:p-[8px]">
              <div className="flex items-center gap-4">
                <div className=" max-w-[200px] max-h-[200px] xl:w-[124px] xl:h-[124px] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <img src={loan.icon} alt='' className='w-full h-full ' />
                </div>

                <div className="flex flex-col min-w-0 w-full bg-white pt-[23px] pr-[20px] pb-[24px] pl-[20px] rounded-[12px] gap-[0px]  ]">
                  <div className="flex flex-col w-full ">
                  <h3 className="text-2xl xl:text-[23.06px] font-semibold text-black mb-4 leading-tight">{loan.title}</h3>
                  <p className="text-[#3F3F3F]  max-w-[300px] w-full  xl:text-[16.5px] leading-[25.6px] mb-6">
                    {loan.description}
                  </p>
                  </div>

                  <a
                  href="/contact" 
                  className="text-[#0BA36C] underline text-[19px] font-semibold inline-flex items-center gap-2 group"
                >
                  Let's Start
                  <img
                    src={arrow}
                    alt="arrow"
                    className="w-6 h-6 transition-transform duration-300 -rotate-45 group-hover:rotate-0"
                  />
                </a>

                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile: Single Column with Vertical Layout */}
        <div className="md:hidden space-y-5">
          {loans.map((loan) => (
             <div key={loan.id} ref={(el) => (cardRefs2.current[loan.id] = el)}
            style={{ animationDelay: `${loan.id * 0}s` }}
            className=" card-base bg-[#0000000a] rounded-tl-[60px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] border-[0.5px] border-[#00000033]  p-[6px] xl:p-[8px]">
              <div className="flex flex-col items-center gap-4">
                <div className=" max-w-[250px] max-h-[250px] w-[250px] h-[250px] xl:w-[124px] xl:h-[124px] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <img src={loan.icon} alt='' className='w-full h-full ' />
                </div>

                <div className="flex flex-col min-w-0 w-full bg-white pt-[23px] pr-[20px] pb-[24px] pl-[20px] rounded-[12px] gap-[0px]  ]">
                  <div className="flex flex-col w-full ">
                  <h3 className=" text-[21.06px] font-semibold text-black mb-4 leading-tight">{loan.title}</h3>
                  <p className="text-[#3F3F3F]  max-w-[300px] w-full  xl:text-[16.5px] leading-[25.6px] mb-6">
                    {loan.description}
                  </p>
                  </div>

                  <a
                  href="/contact" 
                  className="text-[#0BA36C] underline text-[19px] font-semibold inline-flex items-center gap-2 group"
                >
                  Let's Start
                  <img
                    src={arrow}
                    alt="arrow"
                    className="w-6 h-6 transition-transform duration-300 -rotate-45 group-hover:rotate-0"
                  />
                </a>

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>
    </section>
    </>
  );
}